import { useFetchCoupons } from './useFetchCoupons'
import { useQueryClientUtils } from '../useQueryClientUtils'
import { queryKeys as usagesQueryKeys } from '../usages/useQueryUsages'
import { queryKeys as balanceQueryKeys } from '../balance/useQueryBalance'

const redeem = () => {
  const { redeem } = useFetchCoupons()
  const { invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: redeem,
    onSettled: (_, _1, variables) => {
      invalidateQueries([balanceQueryKeys.all(variables).queryKey, usagesQueryKeys.all(variables).queryKey])
    },
  })
}

export const useMutationCoupons = {
  redeem,
}
